import { Attr, HasOne, HasMany, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import ActiveSubscription from "./ActiveSubscription";
import Feedback from "./Feedback";
import NetRecruiterPlacementFee from "./NetRecruiterPlacementFee";
import RecruiterUser from "./RecruiterUser";
import RecruiterJobMetric from "./RecruiterJobMetric";
import RecruiterHiringHubScore from "./RecruiterHiringHubScore";
import Currency from "./Currency";
import LeagueTableAgency from "./LeagueTableAgency";
import Candidate from "./Candidate";
import Sector from "./Sector";

@Model()
class Recruiter extends ApplicationRecord {
  static jsonapiType = "recruiters";

  @Attr() accountType: string;

  @Attr() accountVerified: boolean;

  @Attr() subscribed: boolean;

  @Attr() canEngageOnContracts: boolean;

  @Attr() currencyId: number;

  @Attr() profile: string;

  @Attr() feedbackAverage: number;

  @Attr() hiringHubTestimonial: string;

  @Attr({ persist: false }) instagramUrl: string;

  @Attr() instagramUsername: string;

  @Attr() name: string;

  @Attr() websiteAddress: string;

  @Attr() isNew: boolean;

  @Attr() profileImage: Record<string, unknown>;

  @Attr() profileImageUrl: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() hiringHubScore: number;

  @Attr() portal: boolean;

  @Attr() addressLine1: string;

  @Attr() addressLine2: string;

  @Attr() townOrCity: string;

  @Attr() postcode: string;

  @Attr({ persist: false }) twitterUrl: string;

  @Attr() twitterUsername: string;

  @Attr() facebookUrl: string;

  @Attr() linkedinUrl: string;

  @Attr() glassdoorUrl: string;

  @Attr() existingSince: string;

  @HasMany(RecruiterUser) adminUsers: RecruiterUser[];

  @HasMany(Feedback) feedbacks: Feedback[];

  @HasMany(LeagueTableAgency) leagueTableAgencies: LeagueTableAgency[];

  @HasMany(RecruiterUser) recruiterUsers: RecruiterUser[];

  @HasMany(Candidate) candidates: Candidate[];

  @HasMany(Sector) sectors: Sector[];

  @HasOne(ActiveSubscription) activeSubscription: ActiveSubscription;

  @HasOne(NetRecruiterPlacementFee)
  netRecruiterPlacementFee: NetRecruiterPlacementFee;

  @HasOne(RecruiterJobMetric) recruiterJobMetrics: RecruiterJobMetric;

  @HasOne(RecruiterHiringHubScore)
  recruiterHiringHubScore: RecruiterHiringHubScore;

  @BelongsTo(Currency) currency: Currency;


  get partner() {
    return this.accountType === "partner";
  }

  get isNotAllowedToEngage() {
    return Boolean(this.isNotAllowedToEngageReason);
  }

  get isNotAllowedToEngageReason() {
    if (!this.accountVerified) {
      return `You account has not been verified.<br>
      Please contact your account manager.`;
    }

    if (!this.subscribed) {
      return `You don't currently have a subscription.<br>
      Please contact your account manager.`;
    }

    if (this.partner) {
      return `Partner accounts are unable to engage on jobs.<br>
      Please contact your account manager.`;
    }

    return null;
  }
}

export default Recruiter;
